import React from 'react';
import { PieceSymbol } from 'chess.js';

interface CapturedPiecesProps {
    pieces: PieceSymbol[]; // List of piece symbols representing captured pieces
    advantage: number; // Advantage numerical score (+1, +2, etc)
    color: 'w' | 'b'; // White or black pieces?
}

// Map piece symbols to unicode chess characters
const PIECE_UNICODE: Record<'w' | 'b', Record<PieceSymbol, string>> = {
    w: {
        k: '♔', q: '♕', r: '♖', b: '♗', n: '♘', p: '♙'
    },
    b: {
        k: '♚', q: '♛', r: '♜', b: '♝', n: '♞', p: '♟'
    }
};

const CapturedPieces: React.FC<CapturedPiecesProps> = ({ pieces, advantage, color }) => {
    if (pieces.length === 0 && advantage === 0) return null;

    // We want the color to reflect the color of the *captured* piece.
    // If the captured piece is white 'w', the text color should be white.
    // If black 'b', it should be slightly darker to contrast but visible on dark background.
    const pieceColorClass = color === 'w' ? 'text-white' : 'text-slate-400 drop-shadow-[0_1px_1px_rgba(255,255,255,0.1)]';

    return (
        <div className="flex flex-wrap items-center gap-1.5 min-h-[1.5rem]">
            {pieces.length > 0 && (
                <div className={`flex flex-wrap gap-[-0.2rem] text-[18px] leading-none ${pieceColorClass}`}>
                    {pieces.map((p, idx) => (
                        <span key={idx} className="-ml-1 first:ml-0" title={`Capturada: ${p}`}>
                            {PIECE_UNICODE[color][p]}
                        </span>
                    ))}
                </div>
            )}

            {advantage > 0 && (
                <span className="text-[10px] font-bold text-white/50 ml-1 leading-none mt-1">
                    +{advantage}
                </span>
            )}
        </div>
    );
};

export default CapturedPieces;
